const KEY = 'kam_circle_member';

function isJoined() {
  return localStorage.getItem(KEY) === '1';
}

function render() {
  const joinView = document.getElementById('join-view');
  const memberView = document.getElementById('member-view');
  if (!joinView || !memberView) return;
  const joined = isJoined();
  joinView.style.display = joined ? 'none' : 'block';
  memberView.style.display = joined ? 'block' : 'none';
}

function setJoined(joined) {
  localStorage.setItem(KEY, joined ? '1' : '0');
  render();
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.__kamCircleJoined) setJoined(true);
  render();
  document.getElementById('leave-btn')?.addEventListener('click', () => setJoined(false));
});
